
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { HubTemplateSaveModalComponent } from './template-save-modal.component';
import { DialogTemplateComponent } from '../dialog-template/dialog-template.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    CheckboxModule,
    MessagesModule,
    DialogTemplateComponent,
  ],
  exports: [HubTemplateSaveModalComponent],
  declarations: [HubTemplateSaveModalComponent],
})

export class HubTemplateSaveModalModule { }
